// No code path creates an Overpayment credit, so it is not a type a caller can pick.
export const OVERPAYMENT_NOT_ISSUABLE_MESSAGE = 'Overpayment is not an issuable credit type.';
//# sourceMappingURL=overpayment-not-issuable-message.js.map